import * as T from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

type TooltipProps = {
  children: ReactNode;
  content: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  delayMs?: number;
  className?: string;
};

export function TooltipProvider({ children }: { children: ReactNode }) {
  return <T.Provider delayDuration={300}>{children}</T.Provider>;
}

export function Tooltip({
  children,
  content,
  side = "top",
  align = "center",
  delayMs = 300,
  className,
}: TooltipProps) {
  return (
    <T.Root delayDuration={delayMs}>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content
          side={side}
          align={align}
          sideOffset={8}
          className={cn(
            "z-50 max-w-xs rounded-lg border border-stroke-strong bg-surface-raised",
            "px-3 py-2 text-xs text-ink shadow-lg",
            "data-[state=delayed-open]:animate-in data-[state=closed]:animate-out",
            className,
          )}
        >
          {content}
          <T.Arrow className="fill-surface-raised" />
        </T.Content>
      </T.Portal>
    </T.Root>
  );
}
